import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IntlProvider, FormattedMessage, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

import classes from './ClipDetailsView.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';

import Scroll from 'Flow2/components/UI/Container/Scroll';
import ClipDetailsToolbar from 'Flow2/pages/Clip/ClipDetailsToolbar';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import FullscreenImage from 'Flow2/components/Image/FullscreenImage';
import MediaFileSection from 'Flow2/components/InfoSections/MediaFileSection';
//import VideoPlayer from 'Flow2/pages/Clip/VideoPlayer.js';
import VideoPlayer from 'Flow2/components/VideoPlayer/VideoPlayerNew.js';
import CustomHistory from 'Flow2/components/CustomCollections/CustomDataControllers/CustomHistoryController';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import HelpWindow from 'Flow2/components/UI/Overlay/HelpWindow';

import MEH from 'Flow2/util/MetadataElementHelper.js';
import MPH from 'Flow2/util/MetadataPermissionHelper.js';
import StructureMapping from 'Flow2/util/StructureMapping.js';
import MetadataLanguage from 'Flow2/util/MetadataLanguage.js';
import MediaFile from 'Flow2/util/MediaFile';

import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as actions from 'store/actions/index';

import * as ids from 'Flow2/config/Components';
import { LoadComponent } from 'Flow2/util/ComponentLoader'

export const Tabs = (props) => {
    if (!props.tabs || !props.tabs.length) return "";

    const tabs = props.tabs.map((id) => {
        return (
            <div key={id} className={[props.activeTab === id && props.styles.active].join(' ')} onClick={() => { props.onChangeTab(id, props.hide) }}>
                <h5 className='pointer'><FormattedMessage id={id} /></h5>
            </div>
        );
    });

    return (
        <IntlProvider
            key={props.lang + "_TABS"}
            locale={props.lang}
            messages={props.config.languages[props.lang].messages}
        >
            <div className={props.className.join(' ')}>
                {tabs}
            </div>
        </IntlProvider>
    );
}

export const Tab = (props) => {
    if (props.id !== props.activeTab) return "";

    return (
        <IntlProvider
            key={props.lang + props.id}
            locale={props.lang}
            messages={props.config.languages[props.lang].messages}
        >
            <div className={props.className.join(' ')}>
                {props.children}
            </div>
        </IntlProvider>
    );
}

export const MoveToTrashHandler = (props) => {
    Swal.fire({
        title: props.intl.formatMessage({ id: "popup.title.clips.toTrash" }),
        text: props.intl.formatMessage({ id: "popup.message.clips.toTrash" }),
        showCancelButton: true,
        cancelButtonText: props.intl.formatMessage({ id: "common.cancel" }),
        confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
        confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
        cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
        buttonsStyling: false
    }).then((result) => {
        if (result.value) {
            props.onMoveToTrash && props.onMoveToTrash();
        }
    });
}

export const MediaOutput = (props) => {
    if (!props.mediafile) return "";

    const ext = MediaFile.getFileExtention(props.mediafile.getFilename());
    if (MediaFile.hasVideoExt(ext)) {
        return (
            <VideoPlayer
                key={props.mediafile.id}
                {...props.video}
                clip={props.clip}
                mediafile={props.mediafile} />
        );
    }

    if (MediaFile.hasImageExt(ext)) {
        let filename = props.mediafile.data.filename.replace(/\.\w*$/gm, "");
        let file = "file=" + props.mediafile.data.path + props.mediafile.data.filename;
        let mfc = "/mfc/thumbnail.cgi?";
        let url = window.location.origin;
        if (window.location.origin.indexOf("localhost") !== -1) {
            if(props.config.DEV_HOST) {
                url = props.config.DEV_HOST;
            }
        }
        const src = url + mfc + "width=750&height=420&" + file

        return (
            <img
                key={props.mediafile.id}
                id="MainThumb" alt=""
                onDoubleClick={() => props.handleDoubleClick && props.handleDoubleClick(props.mediafile)}
                src={src/*props.mediafile.url + '&width=750&height=420'*/} />
        );
    }

    if (MediaFile.hasAudioExt(ext)) {
        return (
            <FlexColumn className={props.styles.Audio}>
                {props.clip.mainthumbnail ? <img id="MainThumb" alt="" onDoubleClick={() => props.handleDoubleClick(props.clip.mainthumbnail)} src={MediaFile.localURL() + props.clip.mainthumbnail + '&width=750&height=420'} />
                    : <FontAwesomeIcon size="8x" icon={MediaFile.getFileIcon(props.mediafile.filename)} />}
                <audio 
                    key={props.mediafile.id}
                    onTimeUpdate={(evt) => {
                        props.audio.handleTimeUpdate && props.audio.handleTimeUpdate(evt.target.currentTime); 
                    }}
                    controls>
                    <source src={MediaFile.localURL() + props.mediafile.url} type={MediaFile.getAudioMIME(props.mediafile.filename)} />
                </audio>
            </FlexColumn>
        );
    }

    return (
        <FlexColumn className={props.styles.Other}>
            {props.clip.mainthumbnail ? <img id="MainThumb" alt="" onDoubleClick={() => props.handleDoubleClick(props.clip.mainthumbnail)} src={MediaFile.localURL() + props.clip.mainthumbnail + '&width=750&height=420&' + new Date().getTime()} /> : <FontAwesomeIcon size="8x" icon={MediaFile.getFileIcon(props.mediafile.filename)} />}
        </FlexColumn>
    );
}

// could extract in own component
// paramater: show and text
const tooltip = (props) => {
    if(props.mode !== Metadata.METADATA_MODE_EDIT) return "";
    if(!StructureMapping.hasTooltip(props.elm.obj)) return "";
   
    const content = props.intl.formatMessage({ id: "tooltip."+props.elm.intl, defaultMessage: "Tooltip" });
    
    const cls = props.cls ? (Array.isArray(props.cls) ? props.cls : [ props.cls ]) : [];
   
    return (
        <span 
            className={[classes.Tooltip, ...cls].join(' ')} 
            data-tooltip={props.intl.formatMessage({ id: "tooltip."+props.elm.intl, defaultMessage: "Tooltip" })}>
                <FontAwesomeIcon icon={faQuestionCircle} />
        </span>
    );
}

export const Tooltip = injectIntl(tooltip);

class ClipDetails extends Component {

    structures = {}

    constructor(props) {
        super(props);
        this.languageHelper = new MetadataLanguage(this.props.config.languages, this.props.config.defaultLanguage);
        this.state = this.initState(props);
    }

    initState = (props) => {
        const state = {};

        state.id = props.clip.id;
        state.clip = props.clip;

        state.updated = false;
        state.mode = props.config.METADATA_MODE || Metadata.METADATA_MODE_TEXT;
        state.elements = props.clip.metadata;
        state.changedElements = {};
        state.lang = this.languageHelper.getInitialLang(props.appLang);
        state.fail = props.conditional;
        state.failMessage = props.message;

        state.mediafile = props.clip.mainmediafile;

        state.fullscreen = false;

        // TODO: COULD BE REMOVED ???
        // ONLX NEED IN NLW
        state.currentTime = 0;
        state.setCurrentTime = false;
        //---------------------------

        state.metadataUtil = {};

        try {
            const Util = require(`../../../${process.env.REACT_APP_APPID}/util/metadataOnSaveUtil.js`).default;

            state.metadataUtil.metadataOnSaveUtil = new Util(state.elements);
        } catch (ex) {
            state.metadataUtil.metadataOnSaveUtil = null;
            //console.log(ex);
        }

        this.structures.checkbox = StructureMapping.createCheckboxStructure(Metadata.OBJECT_TYPE_CLIP, props.clip.metadata);

        return state;
    }

    initTabs = (tabs, select = true) => {
        if(select) {
            this.setState({ tabs: tabs, activeTab: tabs[0] });
        } else {
            this.setState({ tabs: tabs, activeTab: "" });
        }
    }

    onChangeTab = (tab, hide = false) => {
        if(hide && this.state.activeTab === tab) {
            this.setState({ activeTab: "" });
        } else {
            this.setState({ activeTab: tab });
        }
    }

    goBackHandler = () => {
        this.props.history.goBack();
    }

    // merge old metadata and changed metadata
    mergedMetadata = (changedMetadata) => {
        const elements = changedMetadata || this.state.changedElements;
        return { ...this.state.elements, ...elements };
    }

    /*
    checkMetadataUtil = (elements) => {
        let elms = { ...elements };

        for (let key in elms) {
            let obj = StructureMapping.getField(Metadata.OBJECT_TYPE_CLIP, key);
            let util = StructureMapping.getUtil(obj);
            if (util && util.file && util.callback) {
                elms = this.state.metadataUtil[util.file][util.callback](elms);
            }
        }
        return elms;
    }
    */
    editHandler = (mode) => {
        switch (this.state.mode) {
            case Metadata.METADATA_MODE_TEXT:
                this.setState({ updated: false, mode: Metadata.METADATA_MODE_EDIT });
                break;
            case Metadata.METADATA_MODE_EDIT:
                let ok = true;
                if (this.state.updated) {
                    ok = this.updateData();
                }
                
                if(ok) {
                    if (this.props.config.METADATA_MODE === Metadata.METADATA_MODE_EDIT) {
                        this.setState({ updated: false, mode: Metadata.METADATA_MODE_EDIT });
                    } else {
                        this.setState({ updated: false, mode: Metadata.METADATA_MODE_TEXT });
                    }
                }
                break;
            default:
                if (this.props.config.METADATA_MODE === Metadata.METADATA_MODE_EDIT) {
                    this.setState({ updated: false, mode: Metadata.METADATA_MODE_EDIT });
                } else {
                    this.setState({ updated: false, mode: Metadata.METADATA_MODE_TEXT });
                }
                break;
        }
    }

    cancelHandler = () => {
        this.props.onResetHandler(Metadata.OBJECT_TYPE_CLIP, this.state.id);
        const state = this.initState(this.props);
        this.setState({ ...state });
    }

    updateData = () => {
        const id = this.state.id;
        let changedElements = this.state.changedElements;
        changedElements = this.checkMetadataUtil(changedElements);
        let elements = this.mergedMetadata(changedElements); //{ ...this.state.elements };
        let fail = this.checkFieldConditions(elements);
        
        // mandatory fail or not
        if(fail.length) {
            this.setState({ fail: fail, failMessage: "popup.title.mandatory.fail" });
            return false;
        }
        
        // validation fail or not
        fail = this.checkValidation(elements);
        if(fail.length) {
            this.setState({ fail: fail, failMessage: "popup.title.validation.fail" });
            return false;
        }

        const components = this.checkReload(changedElements);
        const reloads = components ? { components: [...components] } : null;

        //added history into metadata
        // let history = DataUtil.updateHistoryData(this.props.user.id, CustomTypes.EDIT)
        this.props.updateMetadata(Metadata.OBJECT_TYPE_CLIP, id, { ...elements, history: this.props.customHistory.saveHistory.history }, reloads);
        this.props.setCustomHistory({ ...this.props.customHistory, saving: true });

        this.setState({ fail: [], failMessage: "" });
        return true;
    }

    checkFieldConditions = (elements) => {
        let fail = [];
        for (let key in elements) {
            let obj = StructureMapping.getField(Metadata.OBJECT_TYPE_CLIP, key);
            let condition = StructureMapping.isCondition(obj);
            if (condition && !MEH.isConditionSuccess(condition, elements)) {
                elements[key] = "";
                if (this.structures.checkbox[key]) {
                    for (let value in this.structures.checkbox[key]) {
                        this.structures.checkbox[key][value] = false;
                    }
                }
            }

            if (StructureMapping.isMandatoryEdit(obj)) {
                if (!condition && !elements[key]) {
                    fail.push(key);
                } else {
                    if (condition && MEH.isConditionSuccess(condition, elements) && !elements[key]) {
                        fail.push(key);
                    }
                }
            }
        }
        return fail;
    }

    checkMetadataUtil = (elements) => {
        let elms = { ...elements };

        for (let key in elms) {
            let obj = StructureMapping.getField(Metadata.OBJECT_TYPE_CLIP, key);
            let util = StructureMapping.getUtil(obj);
            if (util && util.file && util.callback) {
                elms = this.state.metadataUtil[util.file][util.callback](elms);
            }
        }
        return elms;
    }
    
    checkValidation = (elements) => {
        let fail = [];
        for (let key in elements) {
            let obj = StructureMapping.getField(Metadata.OBJECT_TYPE_CLIP, key);
            let pattern = StructureMapping.getPattern(obj);
            if(pattern && elements[key] && !(elements[key]+"").match(pattern)) {
                fail.push(key);
            }
        }
        return fail;
    }

    checkReload = (elements) => {
        let reloads = [];
        for (let key in elements) {
            let obj = StructureMapping.getField(Metadata.OBJECT_TYPE_CLIP, key);
            let reload = StructureMapping.isReload(obj);
            if (reload && reloads.indexOf(reload) === -1) {
                reloads.push(reload);
            }
        }
        return reloads;
    }

    showMandatoryMessage = () => {
        if (this.state.fail.length && this.state.failMessage) {
            Swal.fire({
                title: this.props.intl.formatMessage({ id: this.state.failMessage }),
                confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
                confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
                buttonsStyling: false
            }).then((res) => {
                if (res.value) {
                    this.setState({ failMessage: "" });
                }
            });
        }
    }

    langHandler = (lang) => {
        const newLang = this.languageHelper.switchLang(this.state.lang);
        this.setState({ lang: newLang });
    }

    changeHandler = (elements) => {
        const changedElements = {
            ...this.state.changedElements, //...this.state.elements,
            ...elements
        };

        this.setState({
            //elements: changedElements, 
            updated: true,
            changedElements: changedElements
        });

        // callback in calling component (parent)
        if (this.props.onChangeHandler) {
            //this.props.onChangeHandler({ ...elements });
            this.props.onChangeHandler(Metadata.OBJECT_TYPE_CLIP, this.state.id, { ...elements });
        }
    }

    getValue = (field) => {
        const elements = this.mergedMetadata();
        if (field && elements.hasOwnProperty(field)/*this.state.elements[field]*/) {
            return elements[field];
        }
        return "";
    }

    getElement = (key) => {
        const elements = this.mergedMetadata();
        const element = MEH.createElement(Metadata.OBJECT_TYPE_CLIP, key, elements[key] /*this.state.elements[key]*/);

        if (this.showDisplayField(element, key)) {
            element.field = MEH.createDisplayField(element, this);
        } else {
            element.field = MEH.createEditField(element, this);
        }

        return element;
    }

    showDisplayField = (element, key) => {
        if (this.state.mode === Metadata.METADATA_MODE_TEXT) return true;
        if (StructureMapping.isReadonly(element.obj)) return true;
        if (!MPH.hasFieldPermission({ originalObject: this.props.clip.originalObject, type: Metadata.OBJECT_TYPE_CLIP, ...this.props }, key, 'edit')) return true;
        return false;
    }

    getOutput = (key, styles, cls = "") => {
        if (!MPH.hasFieldPermission({ originalObject: this.props.clip.originalObject, type: Metadata.OBJECT_TYPE_CLIP, ...this.props }, key, 'see')) {
            return "";
        }

        try {
            const elements = this.mergedMetadata();
            const element = this.getElement(key);

            if (element) {
                let condition = StructureMapping.isCondition(element.obj);
                if (condition && !MEH.isConditionSuccess(condition, elements/*this.state.elements*/)) {
                    return "";
                }

                return (
                    <div className={[styles.Metaline, classes.Mandatory, (this.state.mode === Metadata.METADATA_MODE_EDIT ? StructureMapping.isMandatoryEdit(element.obj) : "")].join(' ')}>
                        <FormattedMessage id={element.intl} defaultMessage={element.name} />
                        <span className={[cls, classes.Fail, (this.state.fail.length && (this.state.fail.indexOf(element.id) !== -1))].join(' ')}>{element.field}</span>
                        <Tooltip mode={this.state.mode} elm={element} cls={["Right"]}/>
                        <HelpWindow mode={this.state.mode} content={StructureMapping.hasHelp(element.obj)} />
                    </div>
                );

            } else {
                return "";
            }
        } catch (error) {
            console.log(key, error);
            return ""
        }
    }

    onSetMediafile = (file) => {
        if(file) {
            //console.trace();
            this.setState({ mediafile: file });
        }
    }

    // callback to set if player should set time
    handleSetCurrentTime = () => {
        this.setState({
            setCurrentTime: false
        });
    }

    // set time in videoplayer
    onSetCurrentTime = (time) => {
        let currentTime = parseFloat(time);
        currentTime = (currentTime < 0) ? 0 : currentTime;

        this.setState({
            setCurrentTime: true,
            currentTime: currentTime
        });
    }

    // callback from videoplayer after each time update
    handleTimeUpdate = (currentTime) => {
        if (this.state.timeBasedMeta) {
            this.setState({
                currentTime: currentTime
            });
        }
    }

    /*
    OLD VERSION ???
    handleSetCurrentTime = () => {
        this.setState({
            setCurrentTime: false
        });
    }
    */

    // WHERE SHOULD I USE THIS ??? AI ???
    /*
    triggerSetCurrentTime = (time) => {
        let timeArray = time.split(':');
        let currentTime = parseInt(timeArray[0]) * 3600 + parseInt(timeArray[1]) * 60 + parseInt(timeArray[2]) - 1;
        currentTime = (currentTime < 0) ? 0 : currentTime;

        this.setState({
            setCurrentTime: true,
            currentTime: currentTime
        });
    }
    */

    onFullscreen = () => {
        this.setState({ fullscreen: false });
    }

    handleDoubleClick = () => {
        this.setState({ fullscreen: true });
    }


    render = () => {
        if (!this.props.clip) return "";

        const elements = this.mergedMetadata();
        
        //console.log(this.props, this.state);

        const Details = LoadComponent(ids.CLIPDETAILS, {
            ...this.props,
            clip: this.state.clip,
            mode: this.state.mode,
            elements: elements, //this.state.elements,
            changedElements: this.state.changedElements,
            mediafile: this.state.mediafile,
            getOutput: this.getOutput,
            changeHandler: this.changeHandler,
            editHandler: this.editHandler,
            cancelHandler: this.cancelHandler,
            langHandler: this.langHandler,
            lang: this.state.lang,
            initTabs: this.initTabs,
            onChangeTab: this.onChangeTab,
            activeTab: this.state.activeTab,
            onSetMediafile: this.onSetMediafile,
            currentTime: this.state.currentTime,
            onSetCurrentTime: this.onSetCurrentTime,
            video: {
                handleTimeUpdate: this.handleTimeUpdate,
                currentTime: this.state.currentTime,
                setCurrentTime: this.state.setCurrentTime,
                handleSetCurrentTime: this.handleSetCurrentTime
            }
        });
        
        return (
            <>
                {Details}
                {this.showMandatoryMessage()}
            </>
        );
    }

    async showWantSave(nextProps) {
        const { value: confirm } = await Swal.fire({
            title: this.props.intl.formatMessage({ id: "popup.title.metadata.save.close" }),
            text: this.props.intl.formatMessage({ id: "popup.message.metadata.save.close" }),
            showCancelButton: true,
            cancelButtonText: this.props.intl.formatMessage({ id: "common.cancel" }),
            confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            allowOutsideClick: false
        });

        if (confirm) {
            this.updateData();
        } else {
            this.props.onResetHandler(Metadata.OBJECT_TYPE_CLIP, this.state.id);
            const state = this.initState(nextProps);
            this.setState({ ...state });
        }

        // MOVED TO ELSE BECAUSE props.loading INDICATES AN INIT PROCESS
        /*const state = this.initState(nextProps);
        this.setState({ ...state });*/
    }

    handleUpdated = (nextProps) => {
        switch (this.props.config.METADATA_UPDATE_MODE) {
            case Metadata.METADATA_ALWAYS_UPDATE:
                this.alwaysSave(nextProps);
                break;
            case Metadata.METADATA_NO_UPDATE:
                this.withoutSave(nextProps);
                break;
            case Metadata.METADATA_UPDATE_DIALOG:
            default:
                this.showSaveDialog(nextProps);
                break;
        }
    }

    alwaysSave = (nextProps) => {
        this.updateData();
        // REMOVED TO ELSE BECAUSE props.loading INDICATES AN INIT PROCESS
        /*const state = this.initState(nextProps);
        this.setState({ ...state });*/
    }

    withoutSave = (nextProps) => {
        const state = this.initState(nextProps);
        this.setState({ ...state });
    }

    showSaveDialog = (nextProps) => {
        this.showWantSave(nextProps);
    }

    componentWillReceiveProps = (nextProps) => {
        try {
            if (this.props.clip.id !== nextProps.clip.id) {
                if (this.state.updated) {
                    //this.showWantSave(nextProps);
                    this.handleUpdated(nextProps);
                } else {
                    const state = this.initState(nextProps);
                    this.setState({ ...state });
                }
            } else if (nextProps.conditional.length && nextProps.message) {
                this.setState({ fail: nextProps.conditional, failMessage: nextProps.message });
            } else if (nextProps.loading === false && this.props.loading === true) {
                const state = this.initState(nextProps);
                this.setState({ ...state });
            }
        } catch (error) {
            console.log(error);
        }
    }

    //LAMTEST BEGIN
    componentDidUpdate(prev) {
        if (prev.clip && prev.clip.mediafiles && this.props.clip && this.props.clip.mediafiles
            && prev.clip.mediafiles != this.props.clip.mediafiles) {
            this.setState({ clip: this.props.clip });
        }
    }
    //LAMTEST END

    componentWillUnmount() {
        this.props.resetMetadataConditional();
        if (this.state.updated) {
            //this.showWantSave(this.props);
            this.handleUpdated(this.props);
        } else {
            this.props.onResetHandler(Metadata.OBJECT_TYPE_CLIP, this.state.id);
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    const changedElements = state.metadata.changedElements[Metadata.OBJECT_TYPE_CLIP] && state.metadata.changedElements[Metadata.OBJECT_TYPE_CLIP][state.clip.currentClip.id];

    return {
        clip: state.clip.currentClip,
        //clips: state.clipList.clips,
        allClips: state.clipList.clips,
        appLang: state.ui.language,
        loading: state.metadata.loading,
        user: state.auth.user,
        config: state.ui.config,
        conditional: state.metadata.conditional,
        message: state.metadata.message,
        customHistory: state.customData.customHistory,
        changedElements: changedElements,
        clipsLoadedByInternalLink: state.clipList.clipsLoadedByInternalLink // NEED BY ElementHelper:DisplayInternalLink
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateMetadata: (type, id, metadata, reloads) => dispatch(actions.updateMetadata(type, id, metadata, reloads)),
        resetMetadataConditional: () => dispatch(actions.resetMetadataConditional()),
        setCustomHistory: (currentHistory) => dispatch(actions.setCustomHistory(currentHistory)),
        /*onChangeHandler: (type, id, elements) => {
            dispatch(actions.changeMetadata(type, id, elements))
        },*/
        onResetHandler: (type, id, elements) => {
            dispatch(actions.resetMetadata(type, id, elements))
        },
        setCurrentClip: (id) => dispatch(actions.selectClip(id)), // NEED BY ElementHelper:DisplayInternalLink
        loadClipByInternalLink: (id) => dispatch(actions.loadClipByInternalLink(id)),    // NEED BY ElementHelper:DisplayInternalLink
        removeClipByInternalLink: (id) => dispatch(actions.removeClipByInternalLink(id))    // NEED BY ElementHelper:DisplayInternalLink
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(ClipDetails)));
